import React from 'react';
import { UserService } from '../../services/user-service';
import { BARRIER } from '../../helpers/navigation';
import { InputButtonWithIcon as ButtonWithIcon } from '../../components/buttons/button-with-icon';
import { InputGroup } from '../../components/inputs/input-group';
import { CoachMessage } from '../../components/coach-message';

const getPathnameEntity = ({ link }) => {
  return UserService.hasAccount() ? `/${BARRIER}` : link;
};

const Button = React.memo(({ type, to, activity, status, name, isExternal }) => (
  <ButtonWithIcon type={type} to={to} activity={activity} status={status} isExternal={isExternal}>
    {name}
  </ButtonWithIcon>
));

export const Buttons = React.memo(({ primaryButton, secondaryButton }) => (
  <InputGroup type='coach'>
    {primaryButton && <Button type='major' to={getPathnameEntity(primaryButton)} {...primaryButton} />}
    {secondaryButton?.display && <Button type='minor' to={getPathnameEntity(secondaryButton)} {...secondaryButton} />}
  </InputGroup>
));

export const ManualCoach = React.memo(({ message, className, children, ...props }) => (
  <div className={className}>
    <CoachMessage html={message}>{children}</CoachMessage>
    <Buttons {...props} />
  </div>
));
